<template>
  <div class="transfer-form-container">
    <div class="page-header">
      <div class="breadcrumb">ນັກຮຽນ / ການຍົກຍ້າຍໂຮງຮຽນ / <span>{{ isEdit ? 'ແກ້ໄຂຄຳຮ້ອງ' : 'ສ້າງຄຳຮ້ອງໃໝ່' }}</span></div>
      <div class="header-content">
        <h1>{{ isEdit ? 'ແກ້ໄຂຄຳຮ້ອງຍົກຍ້າຍໂຮງຮຽນ' : 'ສ້າງຄຳຮ້ອງຍົກຍ້າຍໂຮງຮຽນນັກຮຽນ' }}</h1>
      </div>
    </div>

    <div v-if="loading" class="state-panel"><i class="fas fa-spinner fa-spin"></i> ກຳລັງໂຫຼດຂໍ້ມູນ...</div>

    <form v-else @submit.prevent="handleSave">
      <div class="panel mb-4">
        <div class="panel-head"><h3><i class="fas fa-user-graduate mr-2"></i> 1. ເລືອກນັກຮຽນທີ່ຈະຍົກຍ້າຍ</h3></div>
        <div class="panel-body">
          <div v-if="!selectedStudent" class="student-search">
            <div class="input-container">
              <i class="fas fa-search search-icon"></i>
              <input type="text" v-model="studentSearch" @input="handleStudentSearch" placeholder="ຄົ້ນຫາດ້ວຍ ຊື່ ຫຼື ລະຫັດນັກຮຽນ...">
            </div>
            <ul v-if="studentResults.length" class="pick-list">
              <li v-for="s in studentResults" :key="s._id" @click="pickStudent(s)">
                <span class="pick-name">{{ s.firstNameLao }} {{ s.familyNameLao }} <span class="pick-grade">ຊັ້ນ {{ s.grade_label }}</span></span>
                <span class="pick-meta">ລະຫັດ: {{ s.student_id }} — {{ s.school_name || s.school_id }}</span>
                <span class="pick-meta">ບ້ານ {{ s.school_village || '-' }}, ເມືອງ {{ s.district_name || '-' }}, ແຂວງ {{ s.prov_name || '-' }}</span>
              </li>
            </ul>
            <div v-else-if="studentSearch && !studentSearching" class="empty-hint">ບໍ່ພົບນັກຮຽນ</div>
          </div>
          <div v-else class="selected-student-card">
            <div class="ssc-info">
              <div class="ssc-name">{{ selectedStudent.firstNameLao }} {{ selectedStudent.familyNameLao }} <span class="pick-grade">ຊັ້ນ {{ selectedStudent.grade_label || selectedStudent.Grade_Code }}</span></div>
              <div class="ssc-meta">ລະຫັດ: {{ selectedStudent.student_id }} — {{ selectedStudent.school_name || selectedStudent.school_id }}</div>
              <div class="ssc-meta">ບ້ານ {{ selectedStudent.school_village || '-' }}, ເມືອງ {{ selectedStudent.district_name || '-' }}, ແຂວງ {{ selectedStudent.prov_name || '-' }}</div>
            </div>
            <button type="button" class="btn-secondary" @click="clearStudent" :disabled="isEdit">
              <i class="fas fa-times"></i> ປ່ຽນນັກຮຽນ
            </button>
          </div>
        </div>
      </div>

      <div class="panel mb-4">
        <div class="panel-head"><h3><i class="fas fa-school mr-2"></i> 2. ໂຮງຮຽນປາຍທາງ</h3></div>
        <div class="panel-body">
          <div class="field-row-3">
            <div class="form-group">
              <label>ແຂວງ <span class="req">*</span></label>
              <select v-model="destProvId" @change="onDestProvChange">
                <option value="">-- ເລືອກແຂວງ --</option>
                <option v-for="p in provinces" :key="p.value" :value="p.value">{{ p.text }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>ເມືອງ <span class="req">*</span></label>
              <select v-model="destDistrictId" @change="onDestDistChange" :disabled="!destProvId">
                <option value="">-- ເລືອກເມືອງ --</option>
                <option v-for="d in destDistricts" :key="d.value" :value="d.value">{{ d.text }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>ໂຮງຮຽນ <span class="req">*</span></label>
              <select v-model="form.to_school_id" :disabled="!destDistrictId">
                <option value="">-- ເລືອກໂຮງຮຽນ --</option>
                <option v-for="s in destSchools" :key="s.school_id" :value="s.school_id">{{ s.school_name_lao }}</option>
              </select>
            </div>
          </div>
          <div class="field-row">
            <div class="form-group">
              <label>ຊັ້ນຮຽນທີ່ຂໍເຂົ້າຮຽນ <span class="req">*</span></label>
              <select v-model="form.target_grade">
                <option value="">-- ເລືອກຊັ້ນຮຽນ --</option>
                <option v-for="g in gradeOptions" :key="g.value" :value="g.value">{{ g.text }}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label>ເຫດຜົນການຍົກຍ້າຍ <span class="req">*</span></label>
            <textarea v-model="form.reason" rows="3" placeholder="ລະບຸເຫດຜົນການຍົກຍ້າຍໂຮງຮຽນ"></textarea>
          </div>
        </div>
      </div>

      <div class="panel mb-4">
        <div class="panel-head"><h3><i class="fas fa-file-upload mr-2"></i> 3. ເອກະສານແນບ (ໃບຄຳຮ້ອງທີ່ເຊັນ/ຢັ້ງຢືນແລ້ວ, ຂໍ້ມູນການສຶກສາ)</h3></div>
        <div class="panel-body">
          <p class="hint-text">
            ບັນທຶກເປັນຮ່າງກ່ອນ ແລ້ວກົດ "ພິມແບບຟອມ" ຢູ່ໜ້າປະຫວັດຄຳຮ້ອງ ເພື່ອພິມ ແລະ ເຊັນ, ຈາກນັ້ນ scan ອັບໂຫລດຄືນທີ່ນີ້ກ່ອນສົ່ງຄຳຮ້ອງ.
          </p>
          <label class="upload-label">
            <i class="fas fa-paperclip"></i> ເລືອກເອກະສານ (ຫຼາຍໄຟລ໌)
            <input type="file" multiple @change="handleMultiFileUpload" hidden>
          </label>
          <ul class="file-list" v-if="form.attachments.length">
            <li v-for="(f, idx) in form.attachments" :key="idx">
              <i class="fas fa-file-alt"></i> {{ f.name }}
              <button type="button" class="btn-remove-file" @click="removeFile(idx)">×</button>
            </li>
          </ul>
        </div>
      </div>

      <div class="form-actions-wrapper">
        <button type="button" class="btn-cancel" @click="$router.back()">ຍົກເລີກ</button>
        <button type="submit" class="btn-save" :disabled="submitting || !isFormValid">
          <i class="fas fa-save"></i> {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກເປັນຮ່າງ' }}
        </button>
      </div>
    </form>

    <transition name="modal">
      <div v-if="resultModal.show" class="modal-overlay" @mousedown.self="closeResultModal">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon" :class="resultModal.type">
            <i class="fas" :class="resultModal.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'"></i>
          </div>
          <div class="modal-content-area">
            <h2>{{ resultModal.title }}</h2>
            <p>{{ resultModal.message }}</p>
          </div>
          <div class="modal-footer-actions">
            <button class="btn-modal-primary" :class="resultModal.type" @click="closeResultModal">ເຂົ້າໃຈແລ້ວ</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/utils/api';

export default {
  name: 'StudentTransferFormPage',
  props: { id: { type: String, default: null } },
  data() {
    return {
      loading: false,
      submitting: false,
      isEdit: false,
      user: {},
      studentSearch: '',
      studentSearching: false,
      studentResults: [],
      studentSearchTimer: null,
      selectedStudent: null,
      provinces: [],
      destProvId: '',
      destDistricts: [],
      destDistrictId: '',
      destSchools: [],
      gradeOptions: [],
      form: {
        student_id: '',
        to_school_id: '',
        target_grade: '',
        reason: '',
        attachments: []
      },
      resultModal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  computed: {
    isFormValid() {
      return !!(this.selectedStudent && this.form.to_school_id && this.form.target_grade && this.form.reason);
    }
  },
  async mounted() {
    this.loadUserInfo();
    this.fetchProvinces();
    await this.fetchGradeOptions();
    if (this.id) {
      this.isEdit = true;
      this.fetchTransfer(this.id);
    }
  },
  methods: {
    loadUserInfo() {
      const savedInfo = localStorage.getItem('user-info');
      if (savedInfo) {
        try { this.user = JSON.parse(savedInfo); } catch (e) { this.user = {}; }
      }
    },
    async fetchProvinces() {
      try {
        const res = await api.get('/getItems/province/prov_name/prov_id');
        this.provinces = res.data || [];
      } catch (e) { console.error('fetchProvinces error:', e); }
    },
    async fetchGradeOptions() {
      try {
        const res = await api.get('/getItems/class_list/class_desc_lao/id');
        this.gradeOptions = res.data || [];
      } catch (e) { console.error('fetchGradeOptions error:', e); }
    },
    async onDestProvChange() {
      this.destDistrictId = '';
      this.destDistricts = [];
      this.destSchools = [];
      this.form.to_school_id = '';
      if (!this.destProvId) return;
      try {
        const res = await api.get(`/getItemsCondition/district/district_name_lao/district_id/prov_id/${this.destProvId}`);
        this.destDistricts = res.data || [];
      } catch (e) { console.error('fetch districts error:', e); }
    },
    async onDestDistChange() {
      this.destSchools = [];
      this.form.to_school_id = '';
      if (!this.destDistrictId) return;
      try {
        const res = await api.get(`/schools/list-by-district/${this.destDistrictId}`);
        this.destSchools = res.data.rows || [];
      } catch (e) { console.error('fetch schools error:', e); }
    },
    handleStudentSearch() {
      if (this.studentSearchTimer) clearTimeout(this.studentSearchTimer);
      if (!this.studentSearch) { this.studentResults = []; return; }
      this.studentSearchTimer = setTimeout(this.searchStudents, 400);
    },
    async searchStudents() {
      this.studentSearching = true;
      try {
        const params = { limit: 10, search: this.studentSearch };
        if (this.user.org_role === 'desb' && this.user.district_id) params.district_id = this.user.district_id;
        else if (this.user.org_role === 'school' && this.user.school_id) params.school_id = this.user.school_id;
        const res = await api.get('/students/search-with-school', { params });
        this.studentResults = (res.data.rows || []);
      } catch (e) {
        console.error('searchStudents error:', e);
      } finally {
        this.studentSearching = false;
      }
    },
    pickStudent(s) {
      this.selectedStudent = s;
      this.form.student_id = s._id;
      this.studentResults = [];
      this.studentSearch = '';
    },
    clearStudent() {
      this.selectedStudent = null;
      this.form.student_id = '';
    },
    handleMultiFileUpload(event) {
      const files = Array.from(event.target.files || []);
      const maxSize = 5 * 1024 * 1024;
      files.forEach(file => {
        if (file.size > maxSize) {
          this.showResult('error', 'ໄຟລ໌ໃຫຍ່ເກີນໄປ', `${file.name} ຂະໜາດເກີນ 5MB`);
          return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          this.form.attachments.push({ name: file.name, data: e.target.result });
        };
        reader.readAsDataURL(file);
      });
      event.target.value = '';
    },
    removeFile(idx) {
      this.form.attachments.splice(idx, 1);
    },
    async fetchTransfer(transferId) {
      this.loading = true;
      try {
        const res = await api.get(`/get/student_transfers/${transferId}`);
        if (res.data.code === 1 && res.data.rows) {
          const t = res.data.rows;
          if (t.status !== 'Draft') {
            this.$router.replace(`/home/students/transfer/detail/${transferId}`);
            return;
          }
          const gradeMatch = this.gradeOptions.find(g => g.value === t.student_snapshot.Grade_Code);
          this.selectedStudent = {
            _id: t.student_id,
            ...t.student_snapshot,
            school_id: t.from_school_id,
            school_name: t.from_school_name,
            grade_label: gradeMatch ? gradeMatch.text : t.student_snapshot.Grade_Code
          };
          this.form.student_id = t.student_id;
          this.form.to_school_id = t.to_school_id;
          this.form.target_grade = t.target_grade;
          this.form.reason = t.reason;
          this.form.attachments = t.attachments || [];
          this.destProvId = t.to_prov_id;
          await this.onDestProvChange();
          this.destDistrictId = t.to_district_id;
          await this.onDestDistChange();
          this.form.to_school_id = t.to_school_id;
        }
      } catch (e) {
        console.error('fetchTransfer error:', e);
      } finally {
        this.loading = false;
      }
    },
    showResult(type, title, message) {
      this.resultModal = { show: true, type, title, message };
    },
    closeResultModal() {
      const wasSuccess = this.resultModal.type === 'success';
      this.resultModal.show = false;
      if (wasSuccess && this.savedId) {
        this.$router.push(`/home/students/transfer/detail/${this.savedId}`);
      }
    },
    async handleSave() {
      if (!this.isFormValid) return;
      this.submitting = true;
      try {
        let res;
        if (this.isEdit) {
          res = await api.put(`/student-transfers/${this.id}`, {
            to_school_id: this.form.to_school_id,
            target_grade: this.form.target_grade,
            reason: this.form.reason,
            attachments: this.form.attachments
          });
          this.savedId = this.id;
        } else {
          res = await api.post('/student-transfers', {
            student_id: this.form.student_id,
            to_school_id: this.form.to_school_id,
            target_grade: this.form.target_grade,
            reason: this.form.reason,
            attachments: this.form.attachments,
            created_by_name: this.user.fullname || this.user.username
          });
          this.savedId = res.data.insertedId;
        }
        if (res.data.code === 1) {
          this.showResult('success', 'ບັນທຶກສຳເລັດ', 'ບັນທຶກຄຳຮ້ອງເປັນຮ່າງແລ້ວ. ທ່ານສາມາດພິມແບບຟອມ, ອັບໂຫລດເອກະສານ, ແລ້ວສົ່ງຄຳຮ້ອງໄດ້ຢູ່ໜ້າຕໍ່ໄປ.');
        } else {
          this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', res.data.msg || 'ບໍ່ສາມາດບັນທຶກຂໍ້ມູນໄດ້');
        }
      } catch (e) {
        console.error('Save transfer error:', e);
        const msg = (e.response && e.response.data && e.response.data.msg) || 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບເຊີເວີໄດ້';
        this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', msg);
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.transfer-form-container { animation: fadeIn 0.4s ease; }
.state-panel { background: var(--card); border: 1px solid var(--border); border-radius: 10px; padding: 60px 20px; text-align: center; color: var(--text3); }
.mb-4 { margin-bottom: 16px; }
.mr-2 { margin-right: 8px; }
.panel-head h3 { display: flex; align-items: center; font-size: 14px; }

.student-search { position: relative; }
.input-container { position: relative; max-width: 480px; }
.search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--text3); }
.input-container input { width: 100%; padding: 10px 10px 10px 35px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; }
.pick-list { list-style: none; margin-top: 6px; max-width: 560px; border: 1px solid var(--border); border-radius: 8px; overflow: hidden; }
.pick-list li { padding: 10px 14px; cursor: pointer; border-bottom: 1px solid var(--border); display: flex; flex-direction: column; gap: 2px; }
.pick-list li:last-child { border-bottom: none; }
.pick-list li:hover { background: var(--lao-light); }
.pick-name { font-weight: 600; color: var(--text1); font-size: 13px; }
.pick-meta { font-size: 11.5px; color: var(--text3); }
.pick-grade { font-weight: 500; color: var(--lao); font-size: 11.5px; margin-left: 8px; }
.empty-hint { margin-top: 8px; color: var(--text3); font-size: 12.5px; }

.selected-student-card { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background: var(--lao-light); border-radius: 8px; }
.ssc-name { font-weight: 700; color: var(--lao); }
.ssc-meta { font-size: 12px; color: var(--text2); margin-top: 4px; }

.form-group { margin-bottom: 14px; }
.form-group label { display: block; font-size: 12.5px; color: var(--text2); margin-bottom: 6px; font-weight: 500; }
.form-group select, .form-group textarea { width: 100%; padding: 9px 10px; border: 1px solid var(--border); border-radius: 8px; font-size: 13.5px; font-family: inherit; }
.field-row { display: flex; gap: 16px; }
.field-row-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; }
.field-row > .form-group { flex: 1; }
.req { color: var(--danger); }

.hint-text { font-size: 12px; color: var(--text3); margin-bottom: 10px; }
.upload-label {
  display: inline-flex; align-items: center; gap: 8px; padding: 9px 16px; border: 1px dashed var(--lao);
  border-radius: 8px; color: var(--lao); cursor: pointer; font-size: 13px; font-weight: 500;
}
.file-list { list-style: none; margin-top: 12px; display: flex; flex-direction: column; gap: 6px; }
.file-list li { display: flex; align-items: center; gap: 8px; font-size: 12.5px; padding: 6px 10px; background: var(--surface); border-radius: 6px; }
.btn-remove-file { margin-left: auto; border: none; background: none; color: var(--danger); font-size: 16px; cursor: pointer; }

.form-actions-wrapper { display: flex; justify-content: flex-end; gap: 10px; margin-top: 10px; }
.btn-cancel, .btn-save, .btn-secondary {
  border: none; padding: 10px 20px; border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 13.5px; font-family: inherit;
}
.btn-cancel { background: #fff; color: var(--text2); border: 1px solid var(--border); }
.btn-save { background: var(--lao); color: #fff; }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-secondary { background: #fff; color: var(--text2); border: 1px solid var(--border); }

.modal-overlay {
  position: fixed; inset: 0; background: rgba(13,27,42,0.55); display: flex;
  align-items: center; justify-content: center; z-index: 1000; padding: 20px;
}
.custom-modal-card { background: #fff; border-radius: 12px; max-width: 420px; width: 100%; padding: 28px; text-align: center; }
.modal-icon { font-size: 42px; margin-bottom: 12px; }
.modal-icon.success { color: var(--success); }
.modal-icon.error { color: var(--danger); }
.modal-content-area h2 { font-size: 16px; margin-bottom: 8px; color: var(--text1); }
.modal-content-area p { font-size: 13px; color: var(--text2); line-height: 1.6; }
.modal-footer-actions { margin-top: 20px; }
.btn-modal-primary { border: none; padding: 10px 24px; border-radius: 8px; font-weight: 600; cursor: pointer; color: #fff; }
.btn-modal-primary.success { background: var(--success); }
.btn-modal-primary.error { background: var(--danger); }

@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>
